import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class BusinessGoalsGoalInitiativesController extends Controller {
  @service intl;
  @service betaToggle;

  @tracked initiativeFormIsVisible = false;

  queryParams = [
    'grouping',
    'statuses',
    'themes',
    'sources',
    'productManagers',
    'teams',
    'roadmaps',
    'columns',
  ];

  @tracked grouping = null;
  @tracked statuses = [];
  @tracked themes = [];
  @tracked sources = [];
  @tracked productManagers = [];
  @tracked teams = [];
  @tracked columns = [];
  @tracked roadmaps = [];

  @tracked tableSort = '';
  @tracked list = [];

  @action
  toggleInitiativeForm(val) {
    if (val !== undefined) this.initiativeFormIsVisible = val;
    else this.initiativeFormIsVisible = !this.initiativeFormIsVisible;
  }

  @action
  setGoalOnInitiative(initiative) {
    initiative.goals = [this.model];
    initiative.save();
  }

  get columnOptions() {
    const columns = [...this.betaToggle.columnOptions];
    columns.forEach((item) => {
      item.show = this.showColumn(item);
    });
    return columns.slice();
  }

  showColumn(column) {
    if (this.columns.length === 0) {
      if (column.show !== undefined) return column.show;
      return true;
    } else {
      return this.columns.includes(column.label);
    }
  }

  @action
  onGroupingSelect(e) {
    this.grouping = e.value;
  }

  @action
  onStatusSelect(e) {
    this.status = e;
  }

  @action
  onThemeSelect(e) {
    this.themes = e;
  }

  @action
  onSourceSelect(e) {
    this.sources = e;
  }

  @action
  onPmSelect(e) {
    this.productManagers = e;
  }

  @action
  onTeamSelect(e) {
    this.teams = e;
  }

  @action
  handleRoadmapSelect(roadmaps) {
    this.roadmaps = roadmaps;
  }

  @action
  onColumnSelect(values) {
    this.columns = values;
  }
}
